<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--right-small" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="m.417 11 5.417-5L.417 1" stroke="currentColor"/></svg></template>